module.exports = __webpack_public_path__ + "img/bicolAllottee.64bf25f4.jpg";